module.exports = __webpack_public_path__ + "static/img/null-list-icon_dark.55e9922f.png";